import { W as WuiCloseButton$1, d as defineCustomElement$1 } from './p-VRJNF0zT.js';

const WuiCloseButton = WuiCloseButton$1;
const defineCustomElement = defineCustomElement$1;

export { WuiCloseButton, defineCustomElement };
